import { gql, graphQueryBang } from "../../../shared/lib/graphql"
import { serviceQueryFields as ServicesFragment } from "../static_applet_composer/reducers/services"

const PrivateServicesQuery = gql`
  query {
    me {
      private_channels {
        ${ServicesFragment}
      }
    }
  }
`

const ServiceQuery = gql`
  query(
    $channel_module_name: String!
  ) {
    channel(module_name: $channel_module_name) {
      ${ServicesFragment}
    }
  }
`

export function loadPrivateServices() {
  return graphQueryBang(PrivateServicesQuery).then(
    data => data.me.private_channels
  )
}

export function loadService(service) {
  return graphQueryBang(ServiceQuery, {
    channel_module_name: service.module_name,
  }).then(data => data.channel)
}
